import { PICTURE_REQUEST, PICTURE_ERROR, PICTURE_SUCCESS } from '../actions/pictures'
import { AUTH_LOGOUT } from '../actions/auth'
import axios from 'axios'

const state = { status: '', pictureFolders: {} }

const getters = {
  getPictures: state => state.pictureFolders,
}

const actions = {
  [PICTURE_REQUEST]: ({commit, dispatch}, subFolder) => {
    commit(PICTURE_REQUEST)

      const headers = {
        'Accept': 'application/json;charset=UTF-8'
      };

    axios({url:  'members/io/downloads/pictures/folders/' + subFolder, headers, method: 'GET'})
      .then(resp => {
        commit(PICTURE_SUCCESS, resp.data)
      })
      .catch(resp => {
        console.log("picture request error");
        commit(PICTURE_ERROR)
      })
  },
}

const mutations = {
  [PICTURE_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [PICTURE_SUCCESS]: (state, docs) => {
    state.status = 'success'
    //Vue.set(state, 'documents', resp.data)
    state.pictureFolders = docs
  },
  [PICTURE_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.pictureFolders = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
